import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export default function BusinessSelector({ businesses, selectedBusiness, onSelectBusiness }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="p-4 border-b dark:border-gray-700">
      <div
        className="flex items-center justify-between cursor-pointer p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="font-medium text-gray-700 dark:text-gray-200">
          {selectedBusiness ? selectedBusiness.name : "Select a Business"}
        </div>
        {isOpen ? (
          <ChevronDown size={18} className="text-gray-500" />
        ) : (
          <ChevronRight size={18} className="text-gray-500" />
        )}
      </div>

      {isOpen && (
        <div className="mt-2 pl-2 border-l-2 border-gray-200 dark:border-gray-600">
          {businesses.map((business) => (
            <div
              key={business.id || "none"}
              className={`p-2 text-sm rounded-md cursor-pointer ${
                selectedBusiness?.id === business.id
                  ? "bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
                  : "text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
              }`}
              onClick={() => {
                onSelectBusiness(business);
                setIsOpen(false);
              }}
            >
              {business.name}
            </div>
          ))}
          <div className="p-2 text-sm text-blue-600 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer">
            + Add New Business
          </div>
        </div>
      )}
    </div>
  );
}